import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { withRouter } from '../code/withRouter.js';

import Navigator from '../code/Navigator.js';
import LabName from '../code/LabName.js';
import NormalA from '../code/NormalA.js';
import * as d3time from 'd3-time-format'
import { _newspath } from '../code/helper.js'
import { Col, Card } from 'react-bootstrap';

const tParser = d3time.timeParse("%Y-%m-%d")
const oFormat = d3time.timeFormat("%Y %B")

class Home extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        document.title = "FIGX | Home"

        fetch(_newspath)
            .then(response => response.json())
            .then(data => {
                data.sort((a, b) => {
                    a.timeFormatted = tParser(a.time)
                    b.timeFormatted = tParser(b.time)
                    return b.timeFormatted - a.timeFormatted
                })
                this.setState({ 'newsdata': data })
            }).catch(error => {
                console.log(error)
            })
    }

    componentDidUpdate() {
        this.runAfterRender()
    }

    runAfterRender() {
        let id = window.location.href.split('#')[1]
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    render() {
        const labIntro = (
            <>
                Our lab locates within the <NormalA
                    href="https://www.cs.umd.edu/" text="Department of Computer
                                        Science" /> at the <NormalA href="https://umd.edu/" text="University of
                                            Maryland, College Park" />. We work on <b className='bold'>Human-Computer Interaction</b> and <b className='bold'>Information Visualization</b>. We create visual representations, interfaces, and tools to enhance understanding, interaction, and development of computational models, including probabilistic and foundation models.
            </>
        )

        return (
            <div className='page-content'>
                <div className='top-header' style={{ 'marginBottom': 0 }}>
                    <div className="container">
                        <Navigator activeItem='home-nav' />
                    </div>
                </div>

                <div className='mobile-hero mobile-only'>
                  <div className='container'>
                    <div className='mobile-hero-card'>
                        <div className='mobile-hero-top'>
                            <img src='figx-logo.svg' alt='FIGX Lab logo' className='mobile-hero-logo' />
                            <p className='mobile-hero-title'>Welcome to the FIGX Lab</p>
                            <p className='mobile-hero-desc'>{labIntro}</p>
                        </div>
                    </div>
                  </div>
                </div>

                <div className='welcome-block-outside desktop-only'>
                    <div className='welcome-block-inside'>
                        <div className="container">
                            <div className='row align-items-center justify-content-between'>
                                <div className='col-lg-8 welcome-block-inside-container' style={{ 'paddingRight': '0px'}}>
                                    <p className='welcome-text'>Welcome to the FIGX Lab</p>
                                    {labIntro}
                                    <div className='research-areas-tags' style={{ marginTop: '1rem' }}>
                                        {/* <span className='research-tag'>Human-AI Co-Evolution</span> */}
                                        <span className='research-tag'>Human-AI Interaction</span>
                                        <span className='research-tag'>Uncertainty Communication</span>
                                        <span className='research-tag'>Decision-Making</span>
                                        <span className='research-tag'>Infographics</span>
                                        <span className='research-tag'>Creativity</span>
                                    </div>
                                    <br />
                                    <p className='small-note'>The background picture was generated by GPT Image 2.</p>
                                </div>
                                {/* <div className='col-lg-3 text-center'>
                                    <img src='figx-logo-full.svg' id="welcome-logo-right" alt='FIGX Lab logo' />
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="padding-top desktop-only"></div>
                    <div className="padding-top desktop-only"></div>

                    <div className='mobile-sections mobile-only'>
                        <div className='mobile-section-card'>
                            <div className='mobile-section-heading'>
                                <span className='mobile-section-label'>About</span>
                            </div>
                            <div className='mobile-section-body'>
                                FIGX is an acronym for <b className='bold'>Future Intelligent Graphical eXperience</b>. It can be thought of as <b className='bold'>Fig. X</b>, the graphic representation that springs to mind when crafting an article. We chose this name to reflect our lab's commitment to pushing the boundaries of innovation and exploration in graphical experiences.
                            </div>
                        </div>

                        <div className='mobile-section-card'>
                            <div className='mobile-section-body'>
                            <span className='mobile-section-label'>Areas</span>
                                <div className='mobile-section-chips'>
                                    {/* <span className='mobile-section-chip'>Human-AI Co-Evolution</span> */}
                                    <span className='mobile-section-chip'>Human-AI Interaction</span>
                                    <span className='mobile-section-chip'>Uncertainty Communication</span>
                                    <span className='mobile-section-chip'>Decision-Making</span>
                                    <span className='mobile-section-chip'>Infographics</span>
                                    <span className='mobile-section-chip'>Creativity</span>
                                </div>
                            </div>
                        </div>

                        <div className='mobile-section-card' id='news-containter-mobile'>
                            <div className='mobile-section-heading'>
                                <span className='mobile-section-label'>News</span>
                            </div>
                            <div className='mobile-section-body mobile-news-list'>
                                {this.state && this.state.newsdata && this.state.newsdata.map((d, index) => {
                                    return (
                                        <div key={index} className='mobile-news-item'>
                                            <div className='mobile-news-date'>{oFormat(d.timeFormatted)}</div>
                                            <div className='mobile-news-content' dangerouslySetInnerHTML={{ __html: d.htmlContent }} />
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>

                    <div className="row desktop-only">
                        <div className='desktop-only sub-span padding-top'>About FIGX</div>
                        <div id='topic-frontpage' className='col-lg-12 desktop-only' style={{ 'paddingTop': '10px' }}>
                            FIGX is an acronym for <b className='bold'>Future Intelligent Graphical eXperience</b>. It can be thought of as <b className='bold'>Fig. X</b>, the graphic representation that springs to mind when crafting an article. We chose this name to reflect our lab's commitment to pushing the boundaries of innovation and exploration in graphical experiences.
                        </div>

                        <div className="padding-top desktop-only"></div>

                        <div className='desktop-only sub-span padding-top'>Lab news</div>
                        <div id='news-containter' className='desktop-only' style={{ 'paddingTop': '10px' }}>
                            {this.state && this.state.newsdata && this.state.newsdata.map((d, index) => {
                                return (
                                    <div key={index} className='news-item'>
                                        <div className='news-date'>{oFormat(d.timeFormatted)}</div>
                                        <div className='news-content' dangerouslySetInnerHTML={{ __html: d.htmlContent }} />
                                    </div>
                                )
                            })}
                        </div>
                    </div>

                    <div className="padding-top"></div>
                </div>

                <br /><br /><br />
            </div>
        )
    }

}


export default withRouter(Home);
